import React from 'react';
import './App.css';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

class Cart extends React.Component {
        getCourses() {
        let courses = [];
        
        if (Array.isArray(this.props.data)){
         for(let i =0; i < this.props.data.length; i++){
          courses.push (
              <Card key={i} elevation={1} square={true} >

                <p style={{fontWeight:'bolder', 'paddingTop': '5px' ,'paddingLeft': '15px', 'paddingRight': '15px'}}
                    onClick={()=>{
                        this.props.removeCartCourse({
                            course: this.props.data[i].number,
                        })
                    }}
                >
                    {this.props.data[i].number + ": " + this.props.data[i].name}</p>
                    {this.getSections(this.props.data[i].number, i)}
              </Card>
          )
        }
      }
      else{
        for(const course of Object.keys(this.props.data)){
          courses.push (
            <Card>{this.props.data[course].number}</Card>
          )
        }
      }
    
        return courses;
    }

    render() {
        
        const useStyles = makeStyles({
            root: {
                width: "100%",
                },
                bullet: {
                display: 'inline-block',
                margin: '0 2px',
                transform: 'scale(0.8)',
            },
                title: {
                fontSize: 14,
            },
            pos: {
                marginBottom: 12,
            },
        });

        return(
            <>

                <Card square={true} elevation={3} className={useStyles.root} style={{'marginBottom': '30px'}}>
                    <CardContent>
                        <h3 style={{fontWeight: 'bold'}}>Recommendations</h3>
                    </CardContent>
                    {/* {this.getCourses()} */}
                </Card>
            </>
        );
    }

}

export default Cart;